import { useEffect } from "react";
import history from "./History";

const useBlocker = (blocker: any, when = true) => {
  useEffect(() => {
    if (!when) return;
    const unblock = history.block((tx) => {
      // <-- use history
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };
      blocker(autoUnblockingTx);
    });
    return unblock;
  }, [blocker, when]);
};

export default useBlocker;
